import styled from 'styled-components';
import {
  Column,
  Row,
  Subtitle as DefaultSubtitle,
  Title as DefaultTitle,
  Button as DefaultButton,
  Text,
} from '~components';

export const Container = styled(Row)`
  margin: ${({ theme }) => theme.spacing.km16} auto
    ${({ theme }) => theme.spacing.km0} auto;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
    margin: ${({ theme }) => theme.spacing.km0};
  }
`;

export const IllustrationColumn = styled(Column)`
  flex: 1;
  align-items: center;
  margin-right: 88px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-right: ${({ theme }) => theme.spacing.km0};
    margin-bottom: ${({ theme }) => theme.spacing.km12};
  }
`;

export const DetailsColumn = styled(Column)`
  flex: 1;
`;

export const Title = styled(DefaultTitle)`
  width: 443px;
`;

export const ContactText = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
  letter-spacing: -0.03em;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km14};
  }
`;

export const Button = styled(DefaultButton).attrs({
  variant: 'primary',
  width: 'fit-content',
})`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing.km6};
  }
`;

export const Subtitle = styled(DefaultSubtitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km4};
  width: 378px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km8};
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
